(function () {
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function isSwiper11Ready() {
    return typeof window.HeroBannerSwiper === 'function';
  }

  const swiperLoadPromise = (function loadSwiper() {
    if (isSwiper11Ready()) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      if (!document.querySelector('link[data-hero-banner-swiper]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-hero-banner-swiper', '');
        document.head.appendChild(link);
      }

      const existing = document.querySelector('script[data-hero-banner-swiper]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true' && isSwiper11Ready()) {
          resolve();
          return;
        }
        existing.addEventListener(
          'load',
          () => {
            if (isSwiper11Ready()) {
              resolve();
            } else {
              reject(new Error('Hero banner Swiper failed to initialize'));
            }
          },
          { once: true }
        );
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      if (window.Swiper && !window.__heroBannerSwiperLegacyBackup) {
        window.__heroBannerSwiperLegacyBackup = window.Swiper;
      }

      const script = document.createElement('script');
      script.src = SWIPER_JS;
      script.defer = true;
      script.setAttribute('data-hero-banner-swiper', '');
      script.onload = () => {
        if (typeof window.Swiper === 'function') {
          window.HeroBannerSwiper = window.Swiper;
          if (window.__heroBannerSwiperLegacyBackup) {
            window.Swiper = window.__heroBannerSwiperLegacyBackup;
          }
        }
        script.setAttribute('data-loaded', 'true');
        if (isSwiper11Ready()) {
          resolve();
        } else {
          reject(new Error('Hero banner Swiper failed to initialize'));
        }
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  })();

  function syncSlideVideos(swiper) {
    swiper.slides.forEach((slide, index) => {
      const video = slide.querySelector('.hero-banner__video');
      if (!video) return;

      if (index === swiper.activeIndex) {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function initHeroBanner(section) {
    if (!section || section.dataset.heroBannerInitialized === 'true') {
      return;
    }

    const SwiperCtor = window.HeroBannerSwiper;
    if (typeof SwiperCtor !== 'function') {
      return;
    }

    const swiperEl = section.querySelector('.hero-banner__swiper');
    if (!swiperEl) {
      return;
    }

    const slideCount = section.querySelectorAll('.swiper-slide').length;
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    const autoHeight = section.dataset.autoHeight === 'true';
    const paginationEl = section.querySelector('.hero-banner__pagination');
    const prevEl = section.querySelector('.hero-banner__prev');
    const nextEl = section.querySelector('.hero-banner__next');

    const config = {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: slideCount > 1,
      autoHeight,
      speed: 600,
      watchOverflow: true,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            bulletClass: 'hero-banner__dot',
            bulletActiveClass: 'is-active',
            renderBullet(index, className) {
              return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
            },
          }
        : undefined,
      autoplay:
        autoplayEnabled && slideCount > 1
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
            }
          : false,
      on: {
        init(swiper) {
          syncSlideVideos(swiper);
        },
        slideChange(swiper) {
          syncSlideVideos(swiper);
        },
      },
    };

    const instance = new SwiperCtor(swiperEl, config);
    section.dataset.heroBannerInitialized = 'true';
    section._heroBannerSwiper = instance;
  }

  function initAllHeroBanners(root) {
    const scope = root || document;
    scope.querySelectorAll('.hero-banner').forEach(initHeroBanner);
  }

  function boot() {
    swiperLoadPromise.then(() => initAllHeroBanners()).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      swiperLoadPromise
        .then(() => initAllHeroBanners(event.target))
        .catch(() => {});
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section =
      event.target && event.target.classList.contains('hero-banner')
        ? event.target
        : event.target && event.target.querySelector('.hero-banner');
    if (section && section._heroBannerSwiper) {
      section._heroBannerSwiper.destroy(true, true);
      delete section._heroBannerSwiper;
      section.dataset.heroBannerInitialized = 'false';
    }
  });
})();
